import { Box, ColumnLayout, ExpandableSection, SpaceBetween } from '@cloudscape-design/components';
import { FC } from 'react';
import { useLocalStorage } from 'react-use';
import { useAuthContext } from '../contexts/AuthContext';
import { useModuleTranslation } from '../lang';
import { Batch } from '../models/Batch';
import { costPerContainer, costPerUnit, costTotal } from '../utils/cost';

interface ICostProps {
  batch: Batch;
}

const Cost: FC<ICostProps> = ({ batch }) => {
  const { currency } = useAuthContext();
  const [costExpanded, setCostExpanded] = useLocalStorage<boolean>('costExpanded', false);
  const t = useModuleTranslation('Cost');

  return (
    <div style={{ marginTop: 10 }}>
      <ExpandableSection
        variant="container"
        headerText={t.header}
        expanded={costExpanded}
        onChange={({ detail }) => setCostExpanded(detail.expanded)}
      >
        {/* Cost overview */}
        <ColumnLayout columns={2} variant="text-grid">
          <SpaceBetween size="m" direction="horizontal">
            <Box variant="awsui-key-label">{t.total}</Box>
            <Box> {currency(batch ? costTotal(batch).toFixed(2) : '0.00')}</Box>
          </SpaceBetween>
          <SpaceBetween size="m" direction="horizontal">
            <Box variant="awsui-key-label">{t.perLiter}</Box>
            <Box>{currency(batch ? costPerUnit(batch).toFixed(2) : '0.00')}</Box>
          </SpaceBetween>

          {batch?.recipe?.containers?.map((c, idx) => (
            <SpaceBetween size="m" direction="horizontal" key={c.containerItem.id + '-' + idx}>
              <Box variant="awsui-key-label">
                Cost per {c.containerItem.name} ({c.sizeL} L)
              </Box>
              <Box>{currency(costPerContainer(batch, c).toFixed(2))}</Box>
            </SpaceBetween>
          ))}
        </ColumnLayout>
      </ExpandableSection>
    </div>
  );
};

export default Cost;
